import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../utils/api.types";
import { IDocSliceState } from "../utils/docAttach.types";
import { addDoc, deleteDoc, updateDocStatus } from "./docAttachThunk"; 
 
const initialState: IDocSliceState = {
    docs: [],
    status: ApiStatus.IDLE,
    errorMessage: '',
    isDocAttached: false,
    docDetails: undefined,
    selectedDocId: ''
}
 

const docAttachSlice = createSlice({
    name: 'doc',
    initialState: initialState,
    reducers: {
         // Selected address id
         selectedDocID: (state, action) => {
            state.selectedDocId = action.payload || '';
        }

    },
    extraReducers: (builder) => {
        builder

 .addCase(addDoc.pending, (state, action) => {
    state.status = ApiStatus.LOADING;
})
.addCase(addDoc.fulfilled, (state, action) => 
{
    state.status = ApiStatus.SUCCESS;
    state.isDocAttached = true;
    state.docs.push(action.payload.doc);
    state.errorMessage = '';

    toast.success(action.payload.message);
})
.addCase(addDoc.rejected, (state, action) => {
    state.status = ApiStatus.FAILED;
    state.isDocAttached = false;
    state.errorMessage = action.error.message
})
.addCase(updateDocStatus.pending, (state, action) => {
    state.status = ApiStatus.LOADING;
})
.addCase(updateDocStatus.fulfilled, (state, action) => 
{
    state.status = ApiStatus.SUCCESS;
    const { message, invoice: updatedDoc } = action.payload
    state.docs = state.docs.map(item => (item._id === item._id ? { ...item, ...updatedDoc } : item));
    state.errorMessage = '';
    toast.success(message);
})
.addCase(updateDocStatus.rejected, (state, action) => {
    state.status = ApiStatus.FAILED;
})
.addCase(deleteDoc.pending, (state, action) => {
    state.status = ApiStatus.LOADING;
})
.addCase(deleteDoc.fulfilled, (state, action) => {
    state.status = ApiStatus.SUCCESS;
    state.errorMessage = '';

    const { id, message } = action.payload;
    state.docs = state.docs.filter(item => item._id !== id)

    toast.success(message);
})
.addCase(deleteDoc.rejected, (state, action) => {
    state.status = ApiStatus.FAILED;
    state.errorMessage = action.error.message

    toast.success(state.errorMessage);
});
    }
});

export default docAttachSlice.reducer;